export default "__VITE_ASSET__b0993669__"